import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { GridViewModel, GridRowAction } from 'tessa/ui/cards/controls';
import { Guid, DbType, DotNetType } from 'tessa/platform';
import { showViewsDialog } from 'tessa/ui/uiHost';
import { RequestParameterBuilder } from 'tessa/views';
import { ViewParameterMetadata, equalsCriteriaOperator } from 'tessa/views/metadata';
import { CardRow, CardRowState } from 'tessa/cards';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdCommonHelper } from '../Helpers/CdCommonHelper';
import { CdExecutiveDocumentationKinds } from '../Helpers/CdExecutiveDocumentationKinds';
import { CdExecutiveDocumentationClientHelper } from '../Helpers/Cards/CdExecutiveDocumentationClientHelper';

export class CdHiddenWorkTableExtension extends CardUIExtension{
    public initialized(context: ICardUIExtensionContext){        
        if (context.model == null ||
            context.model.card == null) {
        return;
        }
        const card = context.model.card;
        const model = context. model;
        if (card.typeId != CdCardTypes.PkExecutiveDocumentationTypeID){
            return;
        }
        if (model.controls.has("HiddenWorkTable")){
            const section = card.sections.get("PkExecutiveDocumentationHiddenWorksSafetyStructureInfo");
            const hiddenWorkTable = model.controls.get("HiddenWorkTable") as GridViewModel;
            hiddenWorkTable.rowInvoked.add(async e => {
                if (e.action == GridRowAction.Opening){
                    // TES-12554 Отключить процессы по виду документа "Исполнительная схема"
                    /*
                    let cardId = e.row.get("SubjectID");
                    await openCard({
                        cardId: cardId,
                    });
                    */
                    e.cancel = true;
                    return;
                } 
            });

            hiddenWorkTable.rowAdding.add(async e => {
                if (section == null) return;
                let refSection = "PkExecutiveDocumentationInfo";
                let departmentId = card.sections.get("DocumentCommonInfo")!.fields.get("DepartmentID");
                let departmentName = card.sections.get("DocumentCommonInfo")!.fields.get("DepartmentName");
                let objects = card.sections.get("PkObjectsVirtual")!.fields.get("ObjectsLikeString");

                const kindNewIdParameter = new ViewParameterMetadata();
                    kindNewIdParameter.alias = 'EDKindNewId';
                    kindNewIdParameter.caption = 'Вид ИД';
                    kindNewIdParameter.hidden = true;
                    kindNewIdParameter.dataType = DbType.Guid;
                    kindNewIdParameter.multiple = false;
                const kindNewNameParameter = new ViewParameterMetadata();
                    kindNewNameParameter.alias = 'EDKindNewName';
                    kindNewNameParameter.caption = 'Вид ИД';
                    kindNewNameParameter.hidden = false;
                    kindNewNameParameter.dataType = DbType.String;
                    kindNewNameParameter.multiple = false;
                const deparmentIdParameter = new ViewParameterMetadata();
                    deparmentIdParameter.alias = 'DepartmentAuthorId';
                    deparmentIdParameter.caption = 'Организация автора';
                    deparmentIdParameter.hidden = true;
                    deparmentIdParameter.dataType = DbType.Guid;
                    deparmentIdParameter.multiple = false;
                const deparmentNameParameter = new ViewParameterMetadata();
                    deparmentNameParameter.alias = 'DepartmentAuthorName';
                    deparmentNameParameter.caption = 'Организация автора';
                    deparmentNameParameter.hidden = false;
                    deparmentNameParameter.dataType = DbType.String;
                    deparmentNameParameter.multiple = false;
                const objectsParameter = new ViewParameterMetadata();
                    objectsParameter.alias = 'Objects';
                    objectsParameter.caption = 'Объекты';
                    objectsParameter.hidden = true;
                    objectsParameter.dataType = DbType.String;
                    objectsParameter.multiple = false;
                
                const nameParamList = [
                    new RequestParameterBuilder()
                        .withMetadata(kindNewIdParameter)
                        .addCriteria(equalsCriteriaOperator(), CdExecutiveDocumentationKinds.ActOfExaminationOfHiddenWorks, CdExecutiveDocumentationKinds.ActOfExaminationOfHiddenWorks)
                        //.addCriteria(equalsCriteriaOperator(), "f226620d-6c47-4df4-91a0-14a0d8cbdebf", "f226620d-6c47-4df4-91a0-14a0d8cbdebf")
                        .asRequestParameter(),
                    new RequestParameterBuilder()
                        .withMetadata(kindNewNameParameter)
                        .addCriteria(equalsCriteriaOperator(), "Акт освидетельствования скрытых работ", "Акт освидетельствования скрытых работ")
                        .asRequestParameter(),
                    new RequestParameterBuilder()
                        .withMetadata(deparmentIdParameter)
                        .addCriteria(equalsCriteriaOperator(), departmentId, departmentId )
                        .asRequestParameter(),
                    new RequestParameterBuilder()
                        .withMetadata(deparmentNameParameter)
                        .addCriteria(equalsCriteriaOperator(), departmentName, departmentName )
                        .asRequestParameter(),
                    new RequestParameterBuilder()
                        .withMetadata(objectsParameter)
                        .addCriteria(equalsCriteriaOperator(), objects, objects )
                        .asRequestParameter()
                    ];

                let added = false;
                await showViewsDialog(
                  refSection, 
                  async (value) => {
                    if (!value) {
                      return;
                    }

                    let selectedItem = value;
                    if (selectedItem == null
                        || !selectedItem.selectedRow
                        || !section) {
                        e.cancel = true;
                        return;
                    }
            
                    let selectedRow = selectedItem.selectedRow;
                    if (selectedRow == null) {
                      e.cancel = true;
                      return;
                    }

                    let row = new CardRow();
                    row.rowId = Guid.newGuid();
                    CdCommonHelper.SetValueToRowField(row, "SubjectID", selectedRow.get("ActID"), DotNetType.Guid);
                    CdCommonHelper.SetValueToRowField(row, "SubjectSubject", selectedRow.get("ActSubject"), DotNetType.String);
                    CdCommonHelper.SetValueToRowField(row, "SecondaryFullNumber", selectedRow.get("SecondaryFullNumber"), DotNetType.String);
                    CdCommonHelper.SetValueToRowField(row, "СreationDate", selectedRow.get("CreationDate"), DotNetType.DateTime);
                    CdCommonHelper.SetValueToRowField(row, "Author", selectedRow.get("AuthorFullName"), DotNetType.String);
                    CdCommonHelper.SetValueToRowField(row, "Department", selectedRow.get("DepartmentName"), DotNetType.String);
                    CdCommonHelper.SetValueToRowField(row, "State", selectedRow.get("StateName"), DotNetType.String);
                    row.state = CardRowState.Inserted;
                    section!.rows.push(row);
                    added = true;  
                  }, 
                  nameParamList
                );
                e.cancel = true;
                if (added) {
                    CdExecutiveDocumentationClientHelper.SaveCardToUpdateFiles(context);
                }
            });
        }
    }
}